import {
    FETCH_UNIVERSELIST_BEGIN,
    FETCH_UNIVERSELIST_SUCCESS,
    FETCH_UNIVERSELIST_FAILURE,
    FETCH_UNIVERSEMEMBERS_BEGIN,
    FETCH_UNIVERSEMEMBERS_SUCCESS,
    FETCH_UNIVERSEMEMBERS_FAILURE
} from '../constants/universeList';
const memberListStructure={
    "UniverseId": null,
    "UniverseName":null,
    "UniverseDescription": null,
    "UniverseEntityMasterId": null,
    "MaxReturnRange": null,
    "CommonReturnRange": null,
    "CreatedByUserName": null,
    "CreatedDate": null,
    "UniverseMemberDetails": [
    ]
}
const initialState = {
    universeList: [],
    universeListLoading: false,
    memberList:memberListStructure,
    memberDetailsLoading:false,
    error: ""
}


export const getAnalyticsReporting = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_UNIVERSELIST_BEGIN: {
            return {
                ...state,
                universeListLoading: true,
                error: null,
            };
        }
        case FETCH_UNIVERSELIST_FAILURE:
            return {
                ...state,
                universeListLoading: true,
                error: payload.errorMessage
            };
        case FETCH_UNIVERSELIST_SUCCESS:
            return {
                ...state,
                universeList: payload.UniverseList,
                universeListLoading: false,
            };
        case FETCH_UNIVERSEMEMBERS_BEGIN: {
            return {
                ...state,
                memberDetailsLoading: true,
                memberList:memberListStructure,
                error: null,
            };
        }
        case FETCH_UNIVERSEMEMBERS_FAILURE:
            return {
                ...state,
                memberList:memberListStructure,
                memberDetailsLoading: false,
                error: payload.errorMessage
            };
        case FETCH_UNIVERSEMEMBERS_SUCCESS:
            return {
                ...state,
                memberList: payload.universe,
                memberDetailsLoading: false,
            };
        default:
            return state;
    }
}

export default getAnalyticsReporting
